const initialState = {
  user: false,
  notification: false,
  task: false,
  help: false,
  helpRepeatTourAction: null
};

export default initialState;


// WEBPACK FOOTER //
// ./source/client/reducers/header/initialState.js